import { FormNumberInputComponent } from 'src/features/generalForms/builder/types/NumberInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useCallback } from 'react';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { RPDF } from 'src/features/report/react-pdf';

export const FormNumberInput: FormNumberInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (v: number) => {
      let result = props.decimal ? Number(v).toFixed(props.decimal) : v.toString();
      if (props.units) result += ` [${props.units}]`;
      return result;
    },
    [props.decimal, props.units],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return <AnswerPreviewRow<number> value={value} isOptional={props.isOptional} renderValue={renderValue} {...props} />;
};
